import React from 'react';
import FormMiddleWare from '../../../components/Form/FormMiddleware';
import SingleSelect from '../../../components/Form/SingleSelect';
import ValidationView from '../../../components/Form/ValidationView';
import MappingMiddleware from '../../../middleWare/MappingMiddleware';
import { Datatable } from '../../../components/Datatable';
import Swal from 'sweetalert2';
// import { get } from 'https';
import MasterMiddleWare from '../../../middleWare/MasterMiddleWare';

const tableName = `tbl_tech_comp_criticals`;

class MapCompetencyParams extends FormMiddleWare {
  constructor(props) {
    super(props);
    this.state = {
      adminId: '',
      themeOptions: [],
      themeSelected: null,
      themeId: null,
      themeLabelName: null,
      errorthemeSelected: null,
      competencyOptions: [],
      competencySelected: null,
      competencyId: null,
      competencyLabelName: null,
      errorcompetencySelected: null,
      definition: '',
      importance: '',
      knowledgeArea: '',
      performanceParameter: '',
      updateData: false,
      selectboxDisable: false,
      data: []
    };
  }

  async componentDidMount() {
    const adminId = await localStorage.getItem('userId');
    this.setState({ adminId });
    this.getTableMaster(adminId);
    this.getThemeMaster(adminId);
    this.getCompetencyMaster(adminId);
  }

  getTableMaster = async adminId => {
    try {
      const { data } = await MappingMiddleware.getCompetencyParamsData(adminId);
      if (data) {
        this.setState({ data });
      }
    } catch (error) {
      console.error(error);
    }
  };

  getThemeMaster = async adminId => {
    try {
      const { data: themeOptions } = await MappingMiddleware.getThemeMaster(adminId);
      if (themeOptions) {
        this.setState({
          themeOptions
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  getCompetencyMaster = async adminId => {
    try {
      const { data: competencyOptions } = await MappingMiddleware.getMapthemeTocompetencyData(adminId);
      if (competencyOptions) {
        this.setState({
          competencyOptions
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  column = [
    {
      Header: 'Theme',
      accessor: 'themename'
    },
    {
      Header: 'Competency',
      accessor: 'competencyname'
    },
    {
      Header: 'Definition',
      accessor: 'defenition'
    },
    {
      Header: 'Importance',
      accessor: 'important'
    },
    {
      Header: 'Knowledge area',
      accessor: 'critical_knowledge'
    },
    {
      Header: 'Performance Parameter',
      accessor: 'critical_performance'
    },
    {
      Header: 'Edit',
      accessor: 'edit',
      Cell: d => this.edit(d)
    },
    {
      Header: 'Delete',
      accessor: 'delete',
      Cell: d => this.delete(d, tableName)
    }
  ];

  themeSelect = async selectedOption => {
    this.setState({
      themeSelected: selectedOption,
      themeId: selectedOption.value,
      themeLabelName: selectedOption.label
    });
  };

  competencySelect = async selectedOption => {
    this.setState({
      competencySelected: selectedOption,
      competencyId: selectedOption.value,
      competencyLabelName: selectedOption.label
    });
  };

  onSubmit = async () => {
    const { themeId, competencyId, definition, importance, knowledgeArea, performanceParameter, adminId } = this.state;
    if (this.validate(themeId, 'errorthemeSelected', 'Please Select Theme')) return true;
    if (this.validate(competencyId, 'errorcompetencySelected', 'Please Select Competency')) return true;
    const formData = new FormData();
    formData.append('theme', themeId);
    formData.append('competency', competencyId);
    formData.append('defenition', definition);
    formData.append('important', importance);
    formData.append('critical_knowledge', knowledgeArea);
    formData.append('critical_performance', performanceParameter);
    formData.append('cmpId', adminId);

    try {
      const result = await MappingMiddleware.mapCompetencyParamsData(formData);
      if (result) {
        Swal.fire({
          position: 'center',
          type: 'success',
          title: 'Mapping has been completed',
          showConfirmButton: false,
          timer: 1500
        });
        this.getTableMaster(adminId);
        this.setState({
          themeSelected: null,
          themeId: null,
          themeLabelName: null,
          errorthemeSelected: null,
          competencySelected: null,
          competencyId: null,
          competencyLabelName: null,
          errorcompetencySelected: null,
          definition: '',
          importance: '',
          knowledgeArea: '',
          performanceParameter: '',
          selectboxDisable: false,
          updateData: false
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  buttonEdit = value => {
    const index = value.index;
    const previousData = [...this.state.data];
    const getData = { ...previousData[index] };
    this.setState({
      index,
      definition: getData.defenition,
      importance: getData.important,
      knowledgeArea: getData.critical_knowledge,
      performanceParameter: getData.critical_performance,
      selectboxDisable: true,
      updateData: true
    });
  };

  onUpdate = async () => {
    const { index, definition, importance, knowledgeArea, performanceParameter, adminId } = this.state;
    const formData = new FormData();
    formData.append('defenition', definition);
    formData.append('important', importance);
    formData.append('critical_knowledge', knowledgeArea);
    formData.append('critical_performance', performanceParameter);

    const previousData = [...this.state.data];
    const getData = { ...previousData[index] };
    const id = getData.id;
    try {
      /**
       * @param tbl_field_agent : tableName which should be updated
       * @param id : user id which should be updated
       * @param formData : json list value for update
       */
      const result = await MasterMiddleWare.updateMaster(tableName, id, formData);
      if (result) {
        Swal.fire({
          position: 'center',
          type: 'success',
          title: 'Function has been updated',
          showConfirmButton: false,
          timer: 1500
        });
        this.getTableMaster(adminId);
        this.setState({
          themeSelected: null,
          themeId: null,
          themeLabelName: null,
          errorthemeSelected: null,
          competencySelected: null,
          competencyId: null,
          competencyLabelName: null,
          errorcompetencySelected: null,
          definition: '',
          importance: '',
          knowledgeArea: '',
          performanceParameter: '',
          selectboxDisable: false,
          updateData: false
        });
      }
    } catch (error) {
      this.setState({
        data: previousData
      });
      console.log(error);
    }
  };

  render() {
    const {
      themeOptions,
      themeSelected,
      errorthemeSelected,
      competencyOptions,
      competencySelected,
      errorcompetencySelected,
      definition,
      importance,
      knowledgeArea,
      performanceParameter,
      updateData,
      selectboxDisable,
      data
    } = this.state;
    return (
      <React.Fragment>
        <section>
          <div className='container container-sm-fluid mt-100'>
            <div className='row justify-content-center align-items-center'>
              <div className='col-lg-8 col-md-12 col-12'>
                <div className='content-border px-2'>
                  <div className='header-text px-lg-3'>
                    <span>Map Competency Params</span>
                  </div>
                  <hr />
                  <div className='row justify-content-between align-items-center'>
                    <div className='col-lg-1 d-none d-lg-block' />
                    <div className='col-lg-3 col-md-6 col-sm-12 col-12 py-1'>
                      <label className='formLabel' htmlFor="department">Theme</label>
                    </div>
                    <div className='col-lg-5 col-md-6 col-12 py-1'>
                      <SingleSelect handleChange={this.themeSelect} options={themeOptions} selectedService={themeSelected} isDisabled={selectboxDisable} />
                    </div>
                    <div className='col-lg-1 d-none d-lg-block' />
                  </div>
                  <ValidationView errorname={errorthemeSelected} />
                  <div className='row justify-content-between align-items-center'>
                    <div className='col-lg-1 d-none d-lg-block' />
                    <div className='col-lg-3 col-md-6 col-sm-12 col-12 py-1'>
                      <label className='formLabel' htmlFor="function">Competency</label>
                    </div>
                    <div className='col-lg-5 col-md-6 col-12 py-1'>
                      <SingleSelect handleChange={this.competencySelect} options={competencyOptions} selectedService={competencySelected} isDisabled={selectboxDisable} />
                    </div>
                    <div className='col-lg-1 d-none d-lg-block' />
                  </div>
                  <ValidationView errorname={errorcompetencySelected} />
                  <div className='row justify-content-between align-items-center'>
                    <div className='col-lg-1 d-none d-lg-block' />
                    <div className='col-lg-3 col-md-6 col-sm-12 col-12 py-1'>
                      <label className='formLabel' htmlFor="function">Definition</label>
                    </div>
                    <div className='col-lg-5 col-md-6 col-12 py-1'>
                      <textarea className="form-control inputss" rows="3" id="definition" name="definition" placeholder="Please enter definition" onChange={this.handleUserInput} value={definition}></textarea>
                    </div>
                    <div className='col-lg-1 d-none d-lg-block' />
                  </div>
                  <div className='row justify-content-between align-items-center'>
                    <div className='col-lg-1 d-none d-lg-block' />
                    <div className='col-lg-3 col-md-6 col-sm-12 col-12 py-1'>
                      <label className='formLabel' htmlFor="function">Definition</label>
                    </div>
                    <div className='col-lg-5 col-md-6 col-12 py-1'>
                      <textarea className="form-control inputss" rows="3" id="definition" name="definition" placeholder="Please enter definition" onChange={this.handleUserInput} value={definition}></textarea>
                    </div>
                    <div className='col-lg-1 d-none d-lg-block' />
                  </div>
                  <div className='row justify-content-between align-items-center'>
                    <div className='col-lg-1 d-none d-lg-block' />
                    <div className='col-lg-3 col-md-6 col-sm-12 col-12 py-1'>
                      <label className='formLabel' htmlFor="function">Importance</label>
                    </div>
                    <div className='col-lg-5 col-md-6 col-12 py-1'>
                      <textarea className="form-control inputss" rows="3" id="importance" name="importance" placeholder="Please enter importance" onChange={this.handleUserInput} value={importance}></textarea>
                    </div>
                    <div className='col-lg-1 d-none d-lg-block' />
                  </div>
                  <div className='row justify-content-between align-items-center'>
                    <div className='col-lg-1 d-none d-lg-block' />
                    <div className='col-lg-3 col-md-6 col-sm-12 col-12 py-1'>
                      <label className='formLabel' htmlFor="function">Knowledge area</label>
                    </div>
                    <div className='col-lg-5 col-md-6 col-12 py-1'>
                      <textarea
                        className="form-control inputss"
                        rows="3"
                        id="knowledgeArea"
                        name="knowledgeArea"
                        placeholder="Please enter knowledge area"
                        onChange={this.handleUserInput}
                        value={knowledgeArea}
                      ></textarea>
                    </div>
                    <div className='col-lg-1 d-none d-lg-block' />
                  </div>
                  <div className='row justify-content-between align-items-center'>
                    <div className='col-lg-1 d-none d-lg-block' />
                    <div className='col-lg-3 col-md-6 col-sm-12 col-12 py-1'>
                      <label className='formLabel' htmlFor="function">Performance Parameter</label>
                    </div>
                    <div className='col-lg-5 col-md-6 col-12 py-1'>
                      <textarea
                        className="form-control inputss"
                        rows="3"
                        id="performanceParameter"
                        name="performanceParameter"
                        placeholder="Please enter performance parameter"
                        onChange={this.handleUserInput}
                        value={performanceParameter}
                      ></textarea>
                    </div>
                    <div className='col-lg-1 d-none d-lg-block' />
                  </div>
                  <div className='row justify-content-between align-items-center'>
                    <div className='col-lg-1 d-none d-lg-block' />
                    <div className='col-lg-3 col-md-6 col-sm-12 col-12 py-1'>
                    </div>
                    <div className='col-lg-5 col-md-6 col-12 py-1'>
                      {!updateData ? (
                        <button type="button" className="submit-btn" onClick={this.onSubmit}>
                          Submit
                        </button>
                      ) : (
                        <button type="button" className="submit-btn " onClick={this.onUpdate}>
                          Update
                        </button>
                      )}
                    </div>
                    <div className='col-lg-1 d-none d-lg-block' />
                  </div>
                </div>
              </div>
            </div>
            <div className='px-2 col-12 py-5 my-5'>
              {data && <Datatable data={data} columnHeading={this.column} />}
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default MapCompetencyParams;
